import { render, staticRenderFns } from "./DepartmentEdit.vue?vue&type=template&id=18cabb64&scoped=true&"
import script from "./DepartmentEdit.vue?vue&type=script&lang=js&"
export * from "./DepartmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cabb64",
  null
  
)

export default component.exports